/**
 * Dynamic Preference Card — PRI Supply Module
 * OR-Sync Battle View + EHR Handshake + Audit Trail.
 */

import { OpsLayout } from '@/components/ops/OpsLayout';
import { BattleViewDashboard } from '@/components/supply/BattleViewDashboard';
import { SupplyAuditTrailPanel } from '@/components/supply/SupplyAuditTrailPanel';
import { FhirSupplySyncPanel } from '@/components/supply/FhirSupplySyncPanel';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ArrowLeftRight, Lock, Shield } from 'lucide-react';

export default function SupplySync() {
  return (
    <OpsLayout>
      <div className="max-w-7xl mx-auto space-y-1">
        <div className="mb-6">
          <h1 className="text-2xl font-bold tracking-tight">Dynamic Preference Card</h1>
          <p className="text-sm text-muted-foreground mt-1">
            PRI Supply Module — OR-Sync engine maps live dictation against the standard preference card to eliminate waste and ad-hoc pulls.
          </p>
        </div>

        <Tabs defaultValue="battle-view" className="space-y-4">
          <TabsList>
            <TabsTrigger value="battle-view" className="gap-1.5">
              <ArrowLeftRight className="w-3.5 h-3.5" />
              Battle View
            </TabsTrigger>
            <TabsTrigger value="fhir-sync" className="gap-1.5">
              <Shield className="w-3.5 h-3.5" />
              EHR Handshake
            </TabsTrigger>
            <TabsTrigger value="audit-trail" className="gap-1.5">
              <Lock className="w-3.5 h-3.5" />
              Audit Trail
            </TabsTrigger>
          </TabsList>

          <TabsContent value="battle-view">
            <BattleViewDashboard />
          </TabsContent>

          <TabsContent value="fhir-sync">
            <FhirSupplySyncPanel />
          </TabsContent>

          <TabsContent value="audit-trail">
            <SupplyAuditTrailPanel />
          </TabsContent>
        </Tabs>
      </div>
    </OpsLayout>
  );
}
